// Forma de pagamento: seleção única ou dividida, cashback e Confirmar (verbatim;
// troco e dividir viraram componentes, helpers viraram usePagamento).
import { ArrowLeft, CreditCard, Layers, Plus, Trash2 } from "lucide-react";
import { fmt } from "../lib/helpers";
import PixOnlineModal from "../../../components/modals/PixOnlineModal";
import CashbackPagamento from "../CashbackPagamento";
import DialogTroco from "../components/DialogTroco";
import ModalDividir from "../components/ModalDividir";
import NomeCliente from "../components/NomeCliente";
import TeclaAtalho from "../components/TeclaAtalho";
import { usePagamento } from "../hooks/usePagamento";
import { useTeclasPagamento } from "../hooks/useTeclasPagamento";

export default function TelaPagamento({ ctx }) {
  const c = { ...ctx, ...usePagamento(ctx) };
  // Balcão: Tab alterna a forma acesa, Enter escolhe e, definida, finaliza.
  const acesa = useTeclasPagamento(c);
  const { setScreen, telaCls, autoAtendimento, cliente, setEtapaIdent, cashbackAtivo, cashbackDisponivel, cashbackAplicado, cashbackGanho, totalAPagar, saldoCashback, setUsarCashback, setCashbackPendente, paymentMethod, isSubmitting, showChangeDialog, setShowChangeDialog, needsChange, setNeedsChange, changeAmount, setChangeAmount, showPixModal, setShowPixModal, pixOrderId, setPixOrderId, splitPayment, splitPayments, submitOrder, handlePixConfirmed, chipCliente, popupBoasVindas, payments, isCashMethod, handleSelectPayment, splitTotal, splitRemaining, splitComplete, openSplitModal, removeSplitPayment, handleToggleSplit, canSubmitNormal, canSubmitSplit } = c;
  return (
    <div className={`${telaCls} bg-zinc-950 flex flex-col select-none`}>
      {popupBoasVindas}
      <div className="relative bg-zinc-900 border-b border-zinc-800 px-4 py-4 flex items-center gap-3">
        <button onClick={() => setScreen("delivery_type")} className="w-10 h-10 rounded-full bg-zinc-800 hover:bg-zinc-700 flex items-center justify-center"><ArrowLeft className="w-5 h-5 text-zinc-300" /></button>
        <h2 className="text-xl font-bold text-zinc-100 flex-1">Forma de Pagamento</h2>
        {/* Balcão: nome do cliente no centro (NomeCliente); Totem: o chip no canto */}
        {autoAtendimento ? chipCliente("mr-2") : <NomeCliente ctx={c} />}
        {/* Switch dividir */}
        <button onClick={handleToggleSplit} className={`flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-semibold transition-all ${splitPayment ? "bg-orange-500 text-white" : "bg-zinc-800 text-zinc-400 border border-zinc-700"}`}>
          <Layers className="w-4 h-4" />
          Dividir
        </button>
      </div>

      <div className="flex-1 flex flex-col items-center justify-center px-8 overflow-y-auto">
        <div className="w-full max-w-lg space-y-6 py-6">
          <div className="text-center">
            <h2 className="text-3xl md:text-4xl font-black text-zinc-100 mb-2">
              {splitPayment ? "Dividir Pagamento" : "Como vai pagar?"}
            </h2>
            <p className="text-zinc-400">
              {splitPayment ? `Total: R$ ${fmt(totalAPagar)}` : "Selecione a forma de pagamento"}
            </p>
          </div>

          {!splitPayment ? (
            <>
              {/* Modo normal - seleção única */}
              <div className="grid grid-cols-2 gap-4">
                {payments.map((pm, i) => (
                  <button key={pm.id} onClick={() => handleSelectPayment(pm.id)} data-e2e="forma-pagamento" data-acesa={acesa === i ? "1" : "0"} className={`p-8 rounded-2xl border-2 flex flex-col items-center gap-4 transition-all ${acesa === i ? "ring-4 ring-orange-500/40 " : ""}${paymentMethod === pm.id ? "border-orange-500 bg-orange-500/10" : "border-zinc-700 bg-zinc-800 hover:border-zinc-600"}`}>
                    <pm.icon className={`w-12 h-12 ${paymentMethod === pm.id ? "text-orange-500" : "text-zinc-400"}`} />
                    <span className={`text-xl font-semibold ${paymentMethod === pm.id ? "text-orange-500" : "text-zinc-300"}`}>{pm.label}</span>
                  </button>
                ))}
              </div>
              {/* Troco info display */}
              {isCashMethod(paymentMethod) && needsChange !== null && !showChangeDialog && (
                <div className="p-4 rounded-xl bg-zinc-800 border border-zinc-700 text-center">
                  <p className="text-base text-zinc-300" data-e2e="resumo-dinheiro">
                    {needsChange
                      ? <>Recebido R$ {parseFloat(changeAmount).toFixed(2).replace('.', ',')} · <b className="text-green-500">Troco R$ {(parseFloat(changeAmount) - totalAPagar).toFixed(2).replace('.', ',')}</b></>
                      : 'Valor exato, sem troco'}
                  </p>
                  <button onClick={() => { setShowChangeDialog(true); setNeedsChange(null); setChangeAmount(''); }} className="text-sm text-orange-500 hover:text-orange-400 mt-1">Alterar</button>
                </div>
              )}
              {acesa !== null && (
                <p className="text-sm text-zinc-500 flex flex-wrap items-center justify-center gap-x-3 gap-y-1" data-e2e="pagamento-dica">
                  <span className="inline-flex items-center gap-1.5 whitespace-nowrap"><TeclaAtalho>Tab</TeclaAtalho> ou <TeclaAtalho>← →</TeclaAtalho> alterna</span>
                  <span className="inline-flex items-center gap-1.5 whitespace-nowrap"><TeclaAtalho>Enter</TeclaAtalho> escolhe</span>
                  <span className="inline-flex items-center gap-1.5 whitespace-nowrap"><TeclaAtalho>Enter</TeclaAtalho> de novo confirma o pedido</span>
                </p>
              )}
            </>
          ) : (
            <>
              {/* Modo split - lista de parcelas */}
              {splitPayments.length > 0 && (
                <div className="space-y-3">
                  {splitPayments.map((sp, idx) => {
                    const pmInfo = payments.find(p => p.id === sp.method);
                    const PmIcon = pmInfo?.icon || CreditCard;
                    return (
                      <div key={idx} className="flex items-center gap-3 bg-zinc-800 border border-zinc-700 rounded-xl px-4 py-3">
                        <PmIcon className="w-6 h-6 text-orange-500 shrink-0" />
                        <div className="flex-1 min-w-0">
                          <p className="text-base font-semibold text-zinc-100">{sp.label}</p>
                          {sp.troco_precisa && sp.troco_valor && (
                            <p className="text-xs text-green-500">Troco p/ R$ {sp.troco_valor.toFixed(2).replace('.', ',')}</p>
                          )}
                        </div>
                        <span className="text-lg font-bold text-zinc-100">R$ {sp.amount.toFixed(2).replace('.', ',')}</span>
                        <button onClick={() => removeSplitPayment(idx)} className="w-8 h-8 rounded-full bg-red-500/20 hover:bg-red-500/30 flex items-center justify-center transition-colors">
                          <Trash2 className="w-4 h-4 text-red-400" />
                        </button>
                      </div>
                    );
                  })}
                </div>
              )}

              {/* Barra de progresso */}
              <div className="space-y-2">
                <div className="flex justify-between text-sm">
                  <span className="text-zinc-400">Distribuído</span>
                  <span className={`font-bold ${splitComplete ? "text-green-500" : "text-orange-500"}`}>
                    R$ {splitTotal.toFixed(2).replace('.', ',')} / R$ {fmt(totalAPagar)}
                  </span>
                </div>
                <div className="w-full h-3 bg-zinc-800 rounded-full overflow-hidden">
                  <div
                    className={`h-full rounded-full transition-all ${splitComplete ? "bg-green-500" : "bg-orange-500"}`}
                    style={{ width: `${Math.min(100, (splitTotal / totalAPagar) * 100)}%` }}
                  />
                </div>
                {splitRemaining > 0.01 && (
                  <p className="text-center text-sm text-zinc-400">
                    Faltam <span className="font-bold text-orange-500">R$ {splitRemaining.toFixed(2).replace('.', ',')}</span>
                  </p>
                )}
              </div>

              {/* Botão adicionar forma */}
              {!splitComplete && (
                <button onClick={openSplitModal} className="w-full h-14 rounded-xl border-2 border-dashed border-zinc-600 hover:border-orange-500 bg-zinc-800/50 hover:bg-zinc-800 text-zinc-300 hover:text-orange-500 font-semibold text-lg flex items-center justify-center gap-2 transition-all">
                  <Plus className="w-5 h-5" /> Adicionar forma de pagamento
                </button>
              )}
            </>
          )}
        </div>
      </div>

      <div className="bg-zinc-900 border-t border-zinc-800 px-6 py-4">
        <div className="max-w-lg mx-auto">
          {/* Desconto dado no carrinho (30/09/2026): já sai do valor a pagar. */}
          {c.desconto?.montante > 0 && (
            <p className="mb-2 text-sm text-green-400 flex justify-between" data-e2e="pagamento-desconto">
              <span>{c.desconto.desconto.tipo === "coupon" ? `Cupom ${c.desconto.desconto.cupom?.code || ""}` : c.desconto.desconto.tipo === "percent" ? `Desconto ${c.desconto.desconto.valor}%` : "Desconto"}</span>
              <span className="font-bold">− R$ {fmt(c.desconto.montante)}</span>
            </p>
          )}
          <CashbackPagamento
            ativo={cashbackAtivo}
            cliente={cliente}
            saldo={saldoCashback}
            disponivel={cashbackDisponivel}
            aplicado={cashbackAplicado}
            ganho={cashbackGanho}
            onAlternarUso={(v) => setUsarCashback(!!v)}
            onIdentificar={() => { setCashbackPendente(true); setEtapaIdent("cpf"); setScreen("identificacao"); }}
          />
          <button
            onClick={submitOrder}
            disabled={splitPayment ? !canSubmitSplit : !canSubmitNormal}
            className={`w-full h-16 rounded-xl font-bold text-xl flex items-center justify-center gap-3 transition-all ${
              (splitPayment ? !canSubmitSplit : !canSubmitNormal)
                ? "bg-zinc-700 text-zinc-500 cursor-not-allowed"
                : "bg-orange-500 hover:bg-orange-600 text-white shadow-lg active:scale-95"
            }`}
          >
            {isSubmitting ? <div className="animate-spin rounded-full h-6 w-6 border-t-2 border-white" /> : <>CONFIRMAR PEDIDO — R$ {fmt(totalAPagar)}{!autoAtendimento && <TeclaAtalho className="text-sm">Enter</TeclaAtalho>}</>}
          </button>
        </div>
      </div>

      {/* PIX Online Modal */}
      <PixOnlineModal
        open={showPixModal}
        onClose={() => { setShowPixModal(false); setPixOrderId(null); }}
        orderId={pixOrderId}
        customerId={cliente?.id || null}
        amount={totalAPagar}
        onPaymentConfirmed={handlePixConfirmed}
      />

      <DialogTroco ctx={c} />
      <ModalDividir ctx={c} />
    </div>
  );
}
